// extracted by mini-css-extract-plugin
module.exports = {"site_layout_sub_header_background":"BugListingAdmin_site_layout_sub_header_background__2pd87","site_layout_background":"BugListingAdmin_site_layout_background__29JfQ"};